import { render, staticRenderFns } from "./Product1.vue?vue&type=template&id=22ccbfc3&scoped=true&"
import script from "./Product1.vue?vue&type=script&lang=js&"
export * from "./Product1.vue?vue&type=script&lang=js&"
import style0 from "./Product1.vue?vue&type=style&index=0&id=22ccbfc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_5a7zypegj5b2h26m45lhzwpe6a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ccbfc3",
  null
  
)

export default component.exports